import React from "react";
import Lottie from "lottie-react";

const ChatBotBox = ({ ChatBotimage, setOpen, suggestionText }) => {
  const formatMarkdown = (text) => {
    return text?.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>") // bold
        .replace(/\*(.*?)\*/g, "<em>$1</em>") // italic
      .replace(/\n/g, "<br />"); // line breaks
  };
  return (
    <div className="chatboxbody">
      <div className="chatboxinsidebody">
        <div style={{ width: "25%", padding: "30px 10px" }}>
          <Lottie
            animationData={ChatBotimage}
            loop={true}
            autoplay={true}
            style={{ width: 60, height: 60 }}
          />
        </div>
        <div style={{ width: "75%" }} className="textbox_bot">
          <h3 style={{fontSize:"16px"}}>Task Assignment Suggestion:</h3>
          <div
            style={{
              whiteSpace: "pre-wrap",
              fontSize: "15px",
            }}
            dangerouslySetInnerHTML={{ __html: formatMarkdown(suggestionText) }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default ChatBotBox;
